import React from 'react'
import { Dialog } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setAlert } from '../../../redux/alertSlice';
import CloseIcon from "../../../Assests/X.svg"
import alertIcon from "../../../Assests/warning2.webp"
import "./Alert.css"


const Alert = () => {
    const dispatch = useDispatch();
    const alert = useSelector((state) => state?.alert);

    const handleAlertClose = () => {
        dispatch(setAlert({
            message: "",
            type: "", isAlertOpen: false
        }));
    }

    return (
        <Dialog open={alert?.isAlertOpen}
            sx={{
                "& .MuiDialog-paper": {
                    position: "absolute",
                    top: "30%",
                    transition: "right 0.1s ease-in-out",
                },
            }}
        >
            <div className='alert-container'>
                <div className='alert-content'>
                    <div className='alert-content-icon'>
                        <img src={alertIcon} />
                    </div>
                    <span>{alert?.message}</span>
                </div>
                <img className='alert-container-closeIcon' src={CloseIcon} onClick={handleAlertClose} />
            </div>
        </Dialog>

    )
}

export default Alert
